// extracted by mini-css-extract-plugin
module.exports = {"mainSider":"main_mainSider__1jE97","mainHeader":"main_mainHeader__23YnO","balanceBox":"main_balanceBox__3lBJF","mainContent":"main_mainContent__1oGvF"};